// Mobile announcement carousel for Dawn
(() => {
  const MOBILE_MAX = 749;
  const ROTATE_MS = 3000;

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function init() {
    const bar = document.querySelector(".announcement-bar");
    if (!bar) return;

    const messages = Array.from(
      bar.querySelectorAll(".announcement-bar__message")
    );
    if (messages.length <= 1) return;

    // Desktop: let Dawn behave normally
    if (!isMobile()) {
      messages.forEach(m => m.classList.remove("is-active"));
      bar.dataset.mobileCarouselInit = "0";
      return;
    }

    // Reduced motion users
    if (prefersReducedMotion()) {
      messages.forEach((m, i) =>
        m.classList.toggle("is-active", i === 0)
      );
      return;
    }

    // Prevent multiple intervals
    if (bar.dataset.mobileCarouselInit === "1") return;
    bar.dataset.mobileCarouselInit = "1";

    let idx = 0;
    messages.forEach((m, i) =>
      m.classList.toggle("is-active", i === 0)
    );

    setInterval(() => {
      if (!isMobile()) return;
      messages[idx].classList.remove("is-active");
      idx = (idx + 1) % messages.length;
      messages[idx].classList.add("is-active");
    }, ROTATE_MS);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();